<template>
  <component :is="backOrHome"></component>
</template>

<script>
export default {
  computed: {
    backOrHome() {
      const gotoHome = ['start', 'login-loading'];
      if (gotoHome.includes(this.$store.state.route.from.name)) {
        return 'button-home';
      }
      return 'button-back';
    }
  }
};
</script>

<style></style>
